<template>
	<!-- 如果是移动端，执行这里的代码 -->
	<div class="page-index-mobile column-me row-center" v-if="isMobile"></div>
	<!-- 如果是PC端，执行这里的代码 -->
	<div ref="carouselFull" class="page-index column-me row-center" v-else>
		<toubu></toubu>
		<div class="recommendPage1" id="recommendPage1">
			<el-carousel height="100vh" direction="vertical" :autoplay="false" :loop="false" ref="a" @change="qiehuan"
				@mousewheel="rollScroll">
				<el-carousel-item :class="show == 0 ? 'one' : ''">
					<div class="one2">
						<div class="one21">开拓建设</div>
						<div class="one22">以质为根</div>
						<div class="one23">奋勇创新</div>
						<div class="one24">以人为本</div>
					</div>
					<div class="one3" @click="showClick()">
						<div class="">
							<div class="area-box">
								<span class="dot"></span>
								<span class="pulse delay-06"></span>
								<span class="pulse delay-05"></span>
								<span class="pulse delay-04"></span>
							</div>
							<i class="el-icon-arrow-down"></i>
						</div>
						<!-- <i class="el-icon-arrow-down pointer"></i> -->
					</div>
					<div class="one4"></div>
					<div class="one5"></div>
					<div class="one6"></div>
					<div class="one7">
						诚信博软&nbsp;&nbsp;&nbsp;精彩无限
					</div>
					<img class="img1 img1@" src="./../../assets/img/sky.png" />
					<!-- <img class="img2" src="./../../assets/img/cornerlogo.png" /> -->
					<img class="img3" src="./../../assets/img/logo.png" />
					<!-- <img class="img4" src="./../../assets/img/hill.png" /> -->
					<img class="img4" src="./../../assets/img/avm4x-td4g6.webp" />

				</el-carousel-item>
				<el-carousel-item :class="show == 1 ? 'eight' : ''" v-show="show == 1">
					<div class="eight1">博软网络-聚能布局</div>
					<div class="eight2">BORUANWANGLUO</div>
					<img class="eight3" src="./../../assets/img/a7gxw-vlziz.webp" />
					<img class="eight4" src="./../../assets/img/technology.png" />
					<img class="eight5" src="./../../assets/img/ISTIC.png" />
					<img class="eight6" src="./../../assets/img/500460542.png" />
					<img class="eight7" src="./../../assets/img/500460542.png" />
					<div class="eight16">
						软件集成开发
						<img src="../../assets/img/1.png" />
					</div>
					<div class="eight17">区块链技术支撑<img src="../../assets/img/2.png" /></div>
					<div class="eight18">VR虚拟现实技术开发<img src="../../assets/img/3.png" /></div>
					<div class="eight19">运营维护与测试评估<img src="../../assets/img/4.png" /></div>
					<div class="eight20">仿真软件开发<img src="../../assets/img/5.png" /></div>
					<div class="eight21">系统平台化开发<img src="../../assets/img/6.png" /></div>
					<div class="eight22">智能化物联网应用开发<img src="../../assets/img/7.png" /></div>
					<div class="eight23">大数据平台开发<img src="../../assets/img/8.png" /></div>
					<div class="eight24">
						<div class="eight24qiantao">
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />
								<img class="eight2412" src="./../../assets/img/jingcheng.svg" />
								<div class="eight2413">精诚</div>
							</div>
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />	<!-- 之前鼠标放上高亮效果图片 -->
								<img class="eight2412" src="./../../assets/img/yonghu.svg" />
								<div class="eight2413">用户</div>
							</div>
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />
								<img class="eight2412" src="./../../assets/img/diaoyan.svg" />
								<div class="eight2413">调研</div>
							</div>
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />
								<img class="eight2412" src="./../../assets/img/jishu.svg" />
								<div class="eight2413">技术</div>
							</div>
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />
								<img class="eight2412" src="./../../assets/img/yunwei.svg" />
								<div class="eight2413">运维</div>
							</div>
							<div class="eight241">
								<img class="eight2411" src="./../../assets/img/beijing.svg" />
								<img class="eight2414" src="./../../assets/img/beijing.svg" />
								<img class="eight2412" src="./../../assets/img/gaoxiao.svg" />
								<div class="eight2413">高效</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item :class="show == 2 ? 'nine' : ''" v-show="show == 2">
					<div class="nine1">产能架构</div>
					<div class="nine2">CAPACITY ARCHITECTURE</div>
					<img src="../../assets/img/l1.svg" :class="butouming == 1 ? 'shi' : 'xu'" class="nine3" />
					<img src="../../assets/img/lv1.svg" :class="butouming == 2 ? 'shi' : 'xu'" class="nine4" />
					<img src="../../assets/img/h1.svg" :class="butouming == 3 ? 'shi' : 'xu'" class="nine5" />
					<div class="nine6">
						<div class="nine63 pointer srcDiv" @click="butouming = 1">
							<img v-if="butouming != 1" src="../../assets/img/hy_n.svg" />
							<img v-if="butouming == 1" src="../../assets/img/hy_s.svg" />
						</div>
						<div class="nine62 pointer srcDiv" @click="butouming = 2">
							<img v-if="butouming != 2" src="../../assets/img/pt_n.svg" />
							<img v-if="butouming == 2" src="../../assets/img/pt_s.svg" />
						</div>
						<div class="nine61 pointer srcDiv" @click="butouming = 3">
							<img v-if="butouming != 3" src="../../assets/img/fz_n.svg" />
							<img v-if="butouming == 3" src="../../assets/img/fz_s.svg" />
						</div>
					</div>
					<div class="nine7">
						智能通信解决方案
					</div>
					<div class="nine8">
						医疗解决方案
					</div>
					<div class="nine9">
						政务解决方案
					</div>
					<div class="nine10">
						智慧城市解决方案
					</div>
					<div class="nine11">
						教育解决方案
					</div>
					<div class="nine12">
						物联网解决方案
					</div>
					<div class="nine13">
						金融解决方案
					</div>
					<div class="nine14">
						电力解决方案
					</div>
					<div class="nine15">
						企业管理运营分析
					</div>
					<div class="nine16">
						赛事运营分析
					</div>
					<div class="nine17">
						平台化市场运营分析
					</div>
					<div class="nine18">
						电商运营
					</div>
					<div class="nine19">
						定制化模拟仿真
					</div>
					<div class="nine20">
						工程模拟仿真
					</div>
					<div class="nine21">
						战场沙盘仿真模拟
					</div>
					<div class="nine22">
						网络传输模拟仿真
					</div>
					<div class="nine23">
						线路模拟仿真
					</div>
				</el-carousel-item>
				<el-carousel-item :class="show == 3 ? 'two' : ''" v-show="show == 3">
					<div class="two1">项目服务流程</div>
					<div class="two2">PROJECT SERVICE PROCESS</div>
					<div class="two3">
						我们以科学的流程和严谨的专业态度，确保每一个服务项目的实施上线与运行安全
					</div>
					<div class="two4">
						<div class="two41">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_xmqy.svg" />
								</div>
								<div class="text">
									项目签约
								</div>
							</div>
							<div class="xia">
								<div class="onea">需求确认</div>
								<div class="onea">流程制作</div>
								<div class="onea">原型制作</div>
								<div class="onea">功能清单</div>
								<div class="onea">项目排期</div>
								<div class="onea">启动会议</div>
							</div>
						</div>
						<div class="two42">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_sjsj.svg" />
								</div>
								<div class="text">
									视觉设计
								</div>
							</div>
							<div class="xia">
								<div class="onea">设计会议</div>
								<div class="onea">标准制定</div>
								<div class="onea">风格确认</div>
								<div class="onea">成果评审</div>
								<div class="onea">提交归档</div>
							</div>
						</div>
						<div class="two43">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_cxkf.svg" />
								</div>
								<div class="text">
									程序研发
								</div>
							</div>
							<div class="xia">
								<div class="onea">计划规划</div>
								<div class="onea">架构设计</div>
								<div class="onea">进度质量</div>
								<div class="onea">例会审报</div>
							</div>
						</div>
						<div class="two44">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_shcs.svg" />
								</div>
								<div class="text">
									双盒测试
								</div>
							</div>
							<div class="xia">
								<div class="onea">环境搭建</div>
								<div class="onea">BUG管理</div>
								<div class="onea">黑白测试</div>
								<div class="onea">联调测试</div>
								<div class="onea">客户测试</div>
								<div class="onea">体验优化</div>
							</div>
						</div>
						<div class="two45">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_bsys.svg" />
								</div>
								<div class="text">
									布施验收
								</div>
							</div>
							<div class="xia">
								<div class="onea">环境迁移</div>
								<div class="onea">操作说明</div>
								<div class="onea">项目上线</div>
								<div class="onea">资料归档</div>
								<div class="onea">使用培训</div>
							</div>
						</div>
						<div class="two46">
							<div class="shang">
								<div class="logo">
									<img src="./../../assets/img/icon_shyw.svg" />
								</div>
								<div class="text">
									售后运维
								</div>
							</div>
							<div class="xia">
								<div class="onea">安全防护</div>
								<div class="onea">需求追踪</div>
								<div class="onea">运维建议</div>
								<div class="onea">跟进培训</div>
							</div>
						</div>
					</div>
				</el-carousel-item>

				<el-carousel-item :class="show == 4 ? 'three' : ''" v-show="show == 4">
					<div class="three1">全国网络服务</div>
					<div class="three2">NATIONAL SERVICE NETWORK</div>
					<div class="three3">
						<!-- <china></china> -->
						<!-- <span class="flashIcon"></span>
						<span class="flashIcon flashIcon1"></span>
						<span class="flashIcon flashIcon2"></span>
						<span class="flashIcon flashIcon3"></span>
						<span class="flashIcon flashIcon4"></span>
						<span class="flashIcon flashIcon5"></span> -->
					</div>
					<div class="three4">
						<!-- <img src="../../assets/img/map_black_bg.png" alt="" /> -->
						<img src="../../assets/img/001.png" alt="" />
						<span class="flashIcon"></span>
						<span class="flashIcon flashIcon1"></span>
						<span class="flashIcon flashIcon2"></span>
						<span class="flashIcon flashIcon3"></span>
						<span class="flashIcon flashIcon4"></span>
						<span class="flashIcon flashIcon5"></span>
						<span class="flashIcon flashIcon6"></span>
						<span class="flashIcon flashIcon7"></span>
						<span class="flashIcon flashIcon8"></span>
						<span class="flashIcon flashIcon9"></span>
						<span class="flashIcon flashIcon10"></span>
						<span class="flashIcon flashIcon11"></span>
						<span class="flashIcon flashIcon12"></span>
						<span class="flashIcon flashIcon13"></span>
						<span class="flashIcon flashIcon14"></span>
						<span class="flashIcon flashIcon15"></span>
						<span class="flashIcon flashIcon16"></span>
						<div class="three41 txt1">16个服务城市</div>
						<div class="three41 txt2">1000个受益客户</div>
						<div class="three41 txt3">30万受众群体</div>
					</div>
				</el-carousel-item>
				<el-carousel-item :class="show == 5 ? 'six' : ''" v-show="show == 5">
					<div class="six1">
						博软的好伙伴
					</div>
					<div class="six2">
						BORUAN COOPERATIVE
					</div>
					<div class="mateLogo">
						<div v-for="(item,index) in imagelist" :key="index" class="divImg">
							<img :src="item.img" />
						</div>

					</div>
				</el-carousel-item>
				<el-carousel-item :class="show == 6 ? 'seven' : ''" v-show="show == 6">
					<div class="seven1">
						新闻动态
					</div>
					<div class="seven2">
						NEWS AND TRENDS
					</div>
					<div class="newList">
						<!-- <div class=""></div> -->
						<div class="listBox">
							
							<div class="list" v-for="(item,index) in newsLists.slice(0,3)" :key="index" @click="gotowebxinwen(item.id)">
								<div class="time">
									<span class="span1">{{item.sub_time.slice(5,7)}}/{{item.sub_time.slice(8,10)}}</span>
									<span class="span2">{{item.sub_time.slice(0,4)}}</span>
								</div>
								<div class="spanSrc">
									<img :src="item.img" alt="新闻封面图" class="img" />
								</div>
								<div class="title">{{item.title}}</div>	
								<div class="fontTxt">{{item.introduce}}</div>
								<div class="moreList">
									了解更多 <div class="triangle"></div>
								</div>
							</div>
							
						</div>
					</div>
					<div class="moreBox" @click="moreClick()">
						<!-- <img src="../../assets/img/more.svg" alt="" /> -->
						MORE >
					</div>
					<!-- <div class="seven3">
						<img class="seven31" src="./../../assets/img/axrlk-2nu59.webp" />
					</div> -->
					<div class="newsBox" style="display: none;">
						<div class="newsDiv">
							<div v-for="(item,index) in newsLists" :key="index">
								<!-- {{index}} -->
								<div class="divList1" v-if="index%2 == 0" @click="gotowebxinwen(item.id)">
									<div class="divList1Cen pointer" :title="item.introduce">
										<div class="time">{{item.sub_time}}</div>
										<div class="tit">{{item.title}}</div>
										<div class="brief">{{item.introduce}}</div>
									</div>
									<div class="wire"></div>
									<div class="circle"></div>
								</div>

								<div class="divList2" v-if="index%2 == 1" @click="gotowebxinwen(item.id)">
									<div class="circle"></div>
									<div class="wire"></div>
									<div class="divList1Cen pointer" :title="item.introduce">
										<div class="time">{{item.sub_time}}</div>
										<div class="tit">{{item.title}}</div>
										<div class="brief">{{item.introduce}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="newsList" style="display: none;">
							<div class="boxDiv" v-for="(item,key,index) in newsLists" :key="index"
								v-if="(index+1)%2 == 0">
								<div class="newsLocation">
									<span class="data">{{key}}</span>
									<div class="newsCen" v-for="(i,index) in item" :key="index">
										<div @click="gotowebxinwen(i.id)" :title="i.title">{{i.title}}</div>
									</div>
								</div>
								<div class="xloc">
									<div class="dottedLine"></div>
									<div class="dotted"></div>
								</div>
							</div>

							<div class="boxDivs" v-for="(item,key,index) in newsLists" :key="index"
								v-if="(index+1)%2 == 1">
								<div class="xloc">
									<div class="dotted"></div>
									<div class="dottedLine"></div>
								</div>
								<div class="newsLocations">
									<span class="data">{{key}}</span>
									<div class="newsCen" v-for="(i,index) in item" :key="index">
										<div @click="gotowebxinwen(i.id)">{{i.title}}</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item :class="show == 7 ? 'five' : ''" v-show="show == 7">
					<div class="five1">
						资质荣誉
					</div>
					<div class="five2">
						QUALIFICATION HONOR
					</div>
					<div class="five4">
						<div class="recommendPage">
							<swiper :options="swiperOption" ref="mySwiper">
								<swiper-slide v-for="(i,index) in honor" :key="index">
									<img class="img5" :src="i" />
								</swiper-slide>
							</swiper>
							<div class="moreBox" @click="honorListClick()">
								<!-- <img src="../../assets/img/more.svg" alt="" /> -->
								MORE >
							</div>
							<!-- <el-carousel :interval="4000" type="card" height="200px">
								<el-carousel-item v-for="(item,index) in honor" :key="index">
									<img class="img5" :src="item.img" />
								</el-carousel-item>
							</el-carousel>
							 -->
						</div>
					</div>
					<!-- <div>
						<el-carousel :interval="4000" type="card" height="200px">
							<el-carousel-item v-for="(item,index) in honor" :key="index">
								<img class="img5" :src="item.img" />
							</el-carousel-item>
						</el-carousel>
						<div class="more" @click="honorListClick()">
							查看更多
						</div>
					</div> -->

					<!-- <div class="honorBox">
						<el-carousel :options="swiperOption"  type="card" height="200px">
							<el-carousel-item v-for="(item,index) in honor" :key="index">
								<img class="img5" :src="item.img" />
							</el-carousel-item>
						</el-carousel>
					</div> -->




					<div class="dibu" style="display: none;">
						<div class="dianhua">电话：{{ this.jichuxinxi.phone }}</div>
						<div class="dianhua">邮箱：{{ this.jichuxinxi.email }}</div>
						<div class="dianhua">地址：{{ this.jichuxinxi.address }}</div>
						<div class="dianhua">Copyright © 2018 博软网络科技有限公司 版权所有</div>
						<div class="dianhua2">
							<div class="guohui">
								<img src="./../../assets/img/emblem.png" />
							</div>
							<div class="text">鲁ICP备19004722号-2</div>
							<div class="ZZ">
								<img src="./../../assets/img/ZZ.png" />
							</div>
						</div>
					</div>

				</el-carousel-item>

				<el-carousel-item v-show="show == 8">
					<div class="baseBox">
						<div class="txt1">{{jichuxinxi.contact}}</div>
						<div class="txt2">中国·山东·青岛·研创中心</div>
						<div class="txt3">地址：{{jichuxinxi.address}}</div>
						<div class="txt4">联系电话：{{jichuxinxi.phone}}</div>
						<div class="txt5">邮箱：{{jichuxinxi.email}}</div>
						<div class="txt6">邮编：266000</div>
						<div class="txt7">微信公众号</div>
						<div class="txt8">
							<el-image :src="QuickMark" :preview-src-list="QuickMarkList" fit="cover" class="onesrc">
							</el-image>
							<!-- <img src="../../assets/img/QuickMark.jpg" /> -->
						</div>
						<div class="txt9">“扫一扫”更多惊喜</div>
					</div>

					<div class="filing">
						<div class="txt">
							Copyright © 2018 青岛博软网络科技有限公司 版权所有 | 鲁ICP备19004722号-2
						</div>
					</div>

				</el-carousel-item>


			</el-carousel>
		</div>
	</div>
</template>

<script>
	let time = null;
	import Toubu from "@/components/header.vue";
	import China from "@/components/china.vue";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import {
		swiper as swiper1,
		swiperSlide as swiperSlide1,
	} from "vue-awesome-swiper";

	import "swiper/dist/css/swiper.css";
	export default {
		data() {
			return {
				QuickMark: 'http://qiniu.boruankeji.net/a55dae011fc5f522b443f9336d18920f.jpg',
				QuickMarkList: [
					'http://qiniu.boruankeji.net/a55dae011fc5f522b443f9336d18920f.jpg'
				],
				swiperOption1: {
					// effect: "fade",
					loop: false,
					autoplay: true,
					// direction: "vertical",
					// slidesPerView: 1,
					// spaceBetween: 300,
					// speed: 0,
					// mousewheel: true,
					on: {
						// 使用es6的箭头函数，使this指向vue对象
						click: () => {
							console.log("qq");
						},
						slideChangeTransitionStart: function() {
							console.log("swiper 真是垃圾");
							//重点！！！：只有在新的页面加载之前把show变成0，再变成1才可以实现重新加载的效果，页面已经加载完再清空就
							//没有用了，所以第一个不能时间不能太低，但是希望他大一点，可以减少清除css带来的不好看的效果，同时，要考虑到
							//第二个时间的值，如果时间长了才有样式也会很丑，如果两个值时间差的太小，可能导致浏览器无法区分
							//谁先执行
							setTimeout(() => {
								this.show = 0;
							}, 70);
							setTimeout(() => {
								this.show = 1;
							}, 90);
						},
					},
					// pagination: {
					//   el: ".swiper-pagination",
					//   clickable: false,
					// },
				},
				swiperOption: {
					effect: "coverflow",
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: "auto",
					// loop: true,
					autoplay: true, //是否自动播放
					coverflowEffect: {
						rotate: -50,	//旋转
						// stretch: -1000, // slide左右距离
						stretch: -600, // slide左右距离
						depth: 900, // slide前后距离
						modifier: 0.5, //
						slideShadows: false, // 滑块遮罩层
					},
					pagination: {
						el: ".swiper-pagination",
						type: "bullets",
					},
				},
				isMobile: this.$store.state.isMobile === 1,
				show: 0, //是否加载类，用于动画重新加载
				imagelist: [],
				butouming: 1,
				shijian: [],
				shijianclass: [
					"shijian1",
					"shijian2",
					"shijian3",
					"shijian4",
					"shijian5",
					"shijian6",
					"shijian7",
					"shijian8",
				],
				timer: null,
				jichuxinxi: "",
				process: "", //流程
				news: "", //新闻
				company: "", //合作伙伴
				honor: [], //荣誉资质
				newsLists: [],
				varnews: 0,
			};
		},
		components: {
			China,
			swiper,
			swiperSlide,
			swiper1,
			swiperSlide1,
			Toubu
		},
		computed: {
			windowChange() {
				return this.$store.state.isMobile;
			},
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
			swiper1() {
				return this.$refs.mySwiper1.swiper;
			},
		},
		watch: {
			windowChange: function(newVal, oldVal) {
				this.isMobile = newVal === 1;
			},
		},
		mounted() {
			// this.$get(this.$host + "/index/Home/homeInfo").then((res) => {
			// 	console.log("首页内容", res);
			// 	this.honor = res.data.honor;
			// });
			this.$get(this.$host + `/index/Article/articleList?page=${1}`).then((res) => {
				console.log("新闻列表", res);
				this.newsLists = res.data.data.slice(0, 10)
				console.log(this.newsLists, '新闻前10条数据')
			});

			this.$get(this.$host + "/index/Partner/getPartner").then((res) => {
				console.log("合作伙伴", res);
				this.imagelist = res.data;
			});
			this.$get(this.$host + "/index/Home/getBaseInfo").then((res) => {
				console.log("基础信息", res);
				this.jichuxinxi = res.data;
			});
			this.butouming = 1;

			this.$post(this.$host + "/index/Home/companyHonor").then((res) => {
				// 资质荣誉
				// var Img = [];
				// for (var j = 0; j < res.data.other.length; j++) {
				// 	Img.push(res.data.other[j].img)
				// }
				// Img.push(res.data.third_a[0].img)
				// Img.push(res.data.third_a[1].img)
				// Img.push(res.data.third_a[2].img)
				// this.honor = Img
				
				this.honor = [
					'http://qiniu.boruankeji.net/6821bde60d0756f874e88648607659e1.png',
					'http://qiniu.boruankeji.net/dcd68a9231fd4abda479781b54b1f076.png',
					'http://qiniu.boruankeji.net/2b23e38799cf5036b730b474ad8a64dd.png',
					'http://qiniu.boruankeji.net/369c919d1c5ee7295bfbeca5a9dce6a7.png'
				]

			});

			// this.$refs.carouselFull.addEventListener('mousewheel', (e) => {
			// 	clearTimeout(time);
			// 	time = setTimeout(() => {
			// 		this.handle(e);
			// 	}, 500);
			// }) || this.$refs.carouselFull.addEventListener('DOMMouseScroll', (e) => {
			// 	clearTimeout(time);
			// 	time = setTimeout(() => {
			// 		this.handle(e);
			// 	}, 500);
			// });

			// navigator.userAgent.indexOf('Firefox')
			if (navigator.userAgent.indexOf('Firefox') > -1) {
				var mousewheel = 'DOMMouseScroll'
			} else {
				var mousewheel = 'mousewheel'
			}

			this.$refs.carouselFull.addEventListener(mousewheel, (e) => {
				clearTimeout(time);
				time = setTimeout(() => {
					this.handle(e);
				}, 500);
			})


			// this.$refs.carouselFull.addEventListener('DOMMouseScroll', (e) => {
			// 	clearTimeout(time);
			// 	time = setTimeout(() => {
			// 		this.handle(e);
			// 	}, 500);
			// });


			// this.$refs.carouselFull.addEventListener("mousewheel", (e) => {
			// 	clearTimeout(time);
			// 	time = setTimeout(() => {
			// 		this.handle(e);
			// 	}, 500);
			// });
		},
		methods: {
			// 点击箭头进入下一页
			showClick() {
				this.$refs.a.setActiveItem(1);
			},
			honorListClick() {
				this.$router.push({
					name: "honorList",
					// query: {
					// 	id: a,
					// },
				});
			},
			gotowebxinwen(id) {
				this.$router.push({
					name: "singleNews",
					query: {
						id: id,
						type: id,
					},
				});
			},
			// 点击新闻更多
			moreClick(){
				this.$router.push({
					name: "newsList",
					query: {},
				});
			},
			//跳转页面
			gotoweb(a) {
				this.$router.push(a);
			},
			handle(e) {
				// if (e.deltaY > 0 && e.deltaY > 50) {
				// 	this.$refs.a.next();
				// 	console.log("下一张");
				// }
				// if (e.deltaY < 0 && e.deltaY < -50) {
				// 	this.$refs.a.prev();
				// 	console.log("上一张");
				// }
				if (e.wheelDelta < 0 || -e.detail < 0) {
					console.log("下一张")
					this.$refs.a.next();
				}
				if (e.wheelDelta > 0 || -e.detail > 0) {
					console.log("上一张")
					this.$refs.a.prev();
				}
			},
			debounce(fn, wait) {
				console.log("防抖");
				return () => {
					if (this.timer !== null) {
						clearTimeout(this.timer);
					} else {
						console.log("fn", fn);
						this.timer = setTimeout(fn, wait);
					}
				};
			},
			rollScroll(event) {
				console.log("event", event);
			},
			onSwiper(swiper) {
				console.log(swiper);
			},
			onSlideChange() {
				console.log("slide change");
			},
			getData() {
				let that = this;
				let param = {
					page: "",
				};
				that
					.$postRequest(that.$apiConstant.login, param)
					.then((data) => {})
					.catch((error) => {
						console.log(error);
					});
			},
			handleSearch() {
				console.log(1);
			},
			qiehuan(val) {
				// alert(val)
				console.log(val, '--------------')
				// alert(val)
				//重点！！！：只有在新的页面加载之前把show变成0，再变成1才可以实现重新加载的效果，页面已经加载完再清空就
				//没有用了，所以第一个不能时间不能太低，但是希望他大一点，可以减少清除css带来的不好看的效果，同时，要考虑到
				//第二个时间的值，如果时间长了才有样式也会很丑，如果两个值时间差的太小，可能导致浏览器无法区分
				//谁先执行
				// this.show = 0;
				// this.show = 1;
				this.QuickMark = '';
				this.QuickMarkList = [];
				if (val != 8) {
					this.QuickMark = '';
					this.QuickMarkList = [];
				}

				setTimeout(() => {
					if (val == 8) {
						this.QuickMark = 'http://qiniu.boruankeji.net/a55dae011fc5f522b443f9336d18920f.jpg'
						this.QuickMarkList = [
							'http://qiniu.boruankeji.net/a55dae011fc5f522b443f9336d18920f.jpg'
						]
					}
					this.show = val;
				}, 70);
				// setTimeout(() => {
				// 	this.show = 1;
				// }, 90);

			},
		},
	};
</script>

<style lang="scss" scoped>
	.page-index-mobile {}

	.page-index {
		.baseBox {
			width: 100%;
			height: 100%;
			position: relative;
			background: red;
			background: url(../../assets/img/bg_dibu.webp) 50% bottom / cover;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			div {
				margin-bottom: 20px;
				font-size: 22px;
				color: #FFFFFF;
				letter-spacing: 3px;
				font-weight: 500;
			}

			.txt1 {
				font-size: 26px !important;
				color: #E36A00 !important;
			}

			.txt7 {
				// font-size: 26px !important;
				// color: #E36A00 !important;
				margin-top: 40px;
				margin-bottom: 18px !important;
			}

			.txt8 {
				margin-bottom: 13px !important;

				/deep/.el-image {
					width: 130px;
					height: 130px;
					margin-bottom: 0 !important;
				}

				/deep/.el-image-viewer__close {
					margin-top: 80px;
				}

				/deep/.el-icon-circle-close:before {
					color: #fff;
				}
			}

		}

		.filing {
			display: flex;
			justify-content: space-around;
			position: fixed;
			align-items: center;
			bottom: 0;
			width: 100vw;
			height: 5vh;
			z-index: 1;
			background: #2B2B2B;
			opacity: 0.7;

			.txt {
				font-size: 20px;
				color: #A19F9D;
			}
		}

		.dibu {
			display: flex;
			justify-content: space-around;
			position: fixed;
			font-size: 14px;
			align-items: center;
			bottom: 0;
			width: 100vw;
			height: 5vh;
			z-index: 10000000000000000000;
			background-color: #291500;
			color: white;

			.dianhua {
				// flex: 1;
				// margin-left: 5vw;
			}

			.dianhua2 {
				// flex: 1;
				// margin-left: 5vw;
				display: flex;
				align-items: center;

				.text {
					margin-left: 7px;
					margin-right: 7px;
				}

				.guohui {
					img {
						width: 20px;
						// height: 3vw;
						// z-index: 200000000000000000000;
					}
				}

				.ZZ {
					img {
						width: 50px;
					}
				}
			}
		}

		.el-carousel--vertical {
			overflow-y: hidden;
			width: 100vw;
		}

		.shi {
			opacity: 1;
			z-index: 100;
		}

		.xu {
			opacity: 0.6;
		}

		* {
			margin: 0;
			padding: 0;
		}

		.one {
			// position: absolute;
			background-color: #001228;
			z-index: 1000000000;

			.img1 {
				width: 50vw;
				height: 50vw;
				// animation: rotate 600s linear infinite;
				animation: fade-in 200s;
				position: absolute;
				left: 25vw;
				top: 15vh;

				// @keyframes rotate {
				//   from {
				//     transform: rotate(0deg);
				//   }
				//   to {
				//     transform: rotate(360deg);
				//   }
				// }
				@keyframes fade-in {
					0% {
						opacity: 0;
						transform: rotate(0deg);
					}

					/*初始状态 透明度为0*/
					0.5% {
						opacity: 1;
					}

					/*过渡状态 透明度为0*/
					100% {
						opacity: 1;
						transform: rotate(360deg);
					}

					/*结束状态 透明度为1*/
				}
			}

			.img2 {
				position: absolute;
				top: 5vh;
				left: 5vh;
				width: 15vw;
				height: 6vh;
			}

			.img3 {
				// background: red;
				// width: 300px;
				width: 17vw;
				height: 25.1vh;
				position: absolute;
				// top: 210px;
				top: 20vh;
				left: 43vw;
				animation: logo 10s;

				@keyframes logo {
					0% {
						opacity: 0;
					}

					60% {
						opacity: 0;
					}

					100% {
						opacity: 1;
					}
				}
			}

			.img4 {
				width: 100vw;
				height: 50vh;
				position: absolute;
				bottom: -5vh;

				animation: mymove 2s;
				animation-iteration-count: 1;

				@keyframes mymove {
					0% {
						opacity: 0;
					}

					50% {
						opacity: 0;
						bottom: -10vh;
					}

					100% {
						bottom: -5vh;
						opacity: 1;
					}
				}
			}

			.one1 {
				.img5 {
					width: 10vw;
					height: 4vh;
					position: absolute;
					top: 5vh;
					right: 5vw;
				}

				.textwangzhan {
					display: flex;
					top: 5.5vh;
					left: 89vw;
					font-size: 18px;
					 
					font-weight: 400;
					color: #ffffff;
					position: absolute;
				}

				.one11 {
					display: flex;
					position: absolute;
					font-size: 18px;
					color: white;
					flex-direction: column;
					left: 89vw;
					top: 8vh;
					opacity: 0;

					.one111 {
						margin-top: 0.5vh;
						cursor: pointer;
					}
				}
			}

			.one1:hover {
				.one11 {
					opacity: 1;
					// animation: chuxian 2s;
					// @keyframes chuxian {
					//   0% {
					//     opacity: 0;
					//   }
					//   100% {
					//     opacity: 1;
					//   }
					// }
				}
			}

			.one2 {
				.one21 {
					font-size: 48px;
					font-family: HuXiaoBo-ZhenShuai;
					letter-spacing: 0.5vw;
					font-weight: 400;
					color: #f1993a;
					z-index: 100;
					position: absolute;
					left: 30vw;
					top: 50vh;
				}

				.one22 {
					font-size: 48px;
					font-family: HuXiaoBo-ZhenShuai;
					letter-spacing: 0.5vw;
					font-weight: 400;
					color: #f1993a;

					z-index: 100;
					position: absolute;
					left: 45vw;
					top: 50vh;
				}

				.one23 {
					font-size: 48px;
					font-family: HuXiaoBo-ZhenShuai;
					letter-spacing: 0.5vw;
					font-weight: 400;
					color: #f1993a;

					z-index: 100;
					position: absolute;
					left: 43vw;
					top: 60vh;
				}

				.one24 {
					font-size: 48px;
					font-family: HuXiaoBo-ZhenShuai;
					letter-spacing: 0.5vw;
					font-weight: 400;
					color: #f1993a;
					z-index: 100;
					position: absolute;
					left: 58vw;
					top: 60vh;
				}

				.one21,
				.one22,
				.one23,
				.one24 {
					opacity: 0;
					animation: jingtou 10s;

					@keyframes jingtou {
						0% {
							opacity: 0;
						}

						21% {
							opacity: 0;
							font-size: 1000px;
						}

						31% {
							opacity: 1;
							font-size: 48px;
						}

						50% {
							opacity: 1;
							font-size: 48px;
						}

						80% {
							opacity: 0;
						}

						100% {
							opacity: 0;
						}
					}
				}
			}

			.one3 {
				// cursor: pointer;
				/deep/.el-icon-arrow-down{
					cursor: pointer;
					/* 上下动画 */
					-webkit-animation: bounce-down 1.6s linear infinite;
					animation: bounce-down 1.6s linear infinite;
					// font-size: 20px !important;
				}
				@-webkit-keyframes bounce-down {
					25% {
						-webkit-transform: translateY(-4px);
					}
				
					50%,
					100% {
						-webkit-transform: translateY(0);
					}
				
					75% {
						-webkit-transform: translateY(4px);
					}
				}
				
				@keyframes bounce-down {
					25% {
						transform: translateY(-4px);
					}
				
					50%,
					100% {
						transform: translateY(0);
					}
				
					75% {
						transform: translateY(4px);
					}
				}
				.area-box {
					.pulse {
						position: absolute;
						left: 46.4vw;
						top: 87.1vh;
						z-index: 100;
						height: 100px;
						width: 100px;
						border: 10px solid #0075FE;
						-webkit-border-radius: 100px;
						-moz-border-radius: 100px;
						border-radius: 100px;
						-webkit-box-shadow: 0 0 300px #0075FE, 0 0 300px #0075FE inset;
						-moz-box-shadow: 0 0 300px #0075FE, 0 0 300px #0075FE inset;
						box-shadow: 0 0 300px #0075FE, 0 0 300px #0075FE inset;
						// opacity: .12;
						filter: alpha(opacity=0);
						-webkit-animation: warn 2s ease-out both;
						-moz-animation: warn 2s ease-out both;
						-o-animation: warn 2s ease-out both;
						animation: warn 2s ease-out both;
						-webkit-animation-iteration-count: infinite;
						-moz-animation-iteration-count: infinite;
						-o-animation-iteration-count: infinite;
						animation-iteration-count: infinite;
						background: 0 0;
					}

					.delay-04 {
						-webkit-animation-delay: 1.2s;
						-moz-animation-delay: 1.2s;
						-o-animation-delay: 1.2s;
						animation-delay: 1.2s
					}

					.delay-05 {
						-webkit-animation-delay: 1.6s;
						-moz-animation-delay: 1.6s;
						-o-animation-delay: 1.6s;
						animation-delay: 1.6s
					}

					.delay-06 {
						-webkit-animation-delay: 2s;
						-moz-animation-delay: 2s;
						-o-animation-delay: 2s;
						animation-delay: 2s
					}

					@-webkit-keyframes warn {
						0% {
							-webkit-transform: scale(0);
							transform: scale(0);
							opacity: 1
						}

						100% {
							-webkit-transform: scale(1);
							transform: scale(1);
							opacity: 0
						}
					}

					@-moz-keyframes warn {
						0% {
							-moz-transform: scale(0);
							transform: scale(0);
							opacity: 1
						}

						100% {
							-moz-transform: scale(1);
							transform: scale(1);
							opacity: 0
						}
					}

					@-o-keyframes warn {
						0% {
							-o-transform: scale(0);
							transform: scale(0);
							opacity: 1
						}

						100% {
							-o-transform: scale(1);
							transform: scale(1);
							opacity: 0
						}
					}

					@keyframes warn {
						0% {
							-webkit-transform: scale(0);
							-moz-transform: scale(0);
							-o-transform: scale(0);
							transform: scale(0);
							opacity: 1
						}

						100% {
							-webkit-transform: scale(1);
							-moz-transform: scale(1);
							-o-transform: scale(1);
							transform: scale(1);
							opacity: 0
						}
					}

				}

				i {
					position: absolute;
					left: 48vw;
					top: 90vh;
					z-index: 100;
					color: white;
					border-radius: 2px;
					font-size: 40px;
				}
			}

			.one4 {
				position: absolute;
				width: 1px;
				height: 1px;
				background: #9095aa;
				top: 58vh;
				left: 50vw;
				z-index: 10000;
				animation: bianchang 10s;

				@keyframes bianchang {
					0% {
						opacity: 0;
					}

					21% {
						opacity: 1;
						width: 1px;
						height: 1px;
					}

					//前4s是没有变化的
					50% {
						opacity: 1;
						width: 40vw;
						left: 30vw;
					}

					//前10s
					90% {
						width: 40vw;
						left: 30vw;
						opacity: 0;
					}

					100% {
						width: 40vw;
						left: 30vw;
						opacity: 0;
					}
				}
			}

			.one5 {
				position: absolute;
				width: 1px;
				height: 1px;
				background: #9095aa;
				top: 58vh;
				left: 40vw;
				z-index: 10000;
				animation: biangao1 10s;

				@keyframes biangao1 {
					0% {
						opacity: 0;
					}

					21% {
						opacity: 1;
						width: 1px;
						height: 1px;
					}

					//前4s是没有变化的
					50% {
						opacity: 1;
						height: 20vh;
						top: 50vh;
					}

					//前10s
					90% {
						height: 20vh;
						top: 50vh;
						opacity: 0;
					}

					100% {
						height: 20vh;
						top: 50vh;
						opacity: 0;
					}
				}
			}

			.one6 {
				position: absolute;
				width: 1px;
				height: 1px;
				background: #9095aa;
				top: 58vh;
				left: 55vw;
				z-index: 10000;
				animation: biangao2 10s;

				@keyframes biangao2 {
					0% {
						opacity: 0;
					}

					21% {
						opacity: 1;
						width: 1px;
						height: 1px;
					}

					//前4s是没有变化的
					50% {
						opacity: 1;
						height: 20vh;
						top: 50vh;
					}

					//前10s
					90% {
						height: 20vh;
						top: 50vh;
						opacity: 0;
					}

					100% {
						height: 20vh;
						top: 50vh;
						opacity: 0;
					}
				}
			}

			.one7 {
				position: absolute;
				font-size: 45px;
				color: white;
				// margin: auto;
				text-align: center;
				left: 0;
				right: 0;
				top: 47vh;

				animation: chengxin 10s;

				@keyframes chengxin {
					0% {
						opacity: 0;
					}

					75% {
						opacity: 0;
					}

					100% {
						opacity: 1;
					}
				}
			}
		}

		.two {
			width: 100vw;
			height: 100vh;
			// background-image: url(../../assets/img/bg_50.webp);
			// background-size: 100% 100%;
			background: url(../../assets/img/bg4.webp) 50% bottom / cover;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			.two1 {
				font-size: 40px;
				font-weight: 600;
				color: #000000;
				text-align: center;
				text-align: center;
				// margin-top: 148px;
				animation: three111 2s;
				
				@keyframes three111 {
					0% {
						opacity: 0;
						margin-top: 188px;
					}
				
					100% {
						opacity: 1;
					}
				}
			}

			.two2 {
				font-size: 30px;
				color: #666666;
				text-align: center;
				// margin-top: .8vh;
				margin-top: 10px;
				left: 0;
				right: 0;
				text-align: center;
				animation: three333 2s;
				
				@keyframes three333 {
					0% {
						opacity: 0;
						margin-top: 20px;
					}
				
					100% {
						opacity: 1;
					}
				}
			}

			.two3 {
				font-size: 24px;
				color: #666666;
				text-align: center;
				// margin-top: 6.06vh;
				margin-top: 36px;
			}

			.two4 {
				// width: 70vw;
				// margin-left: 15vw;
				// margin-top: 7vh;
				margin-top: 47px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 100px;
					height: 100px;
					// width: 5vw;
					// height: 5vw;
					display: flex;
					align-items: center;
					// margin-left: 3vw;
				}

				.text {
					font-size: 30px;
					font-weight: 600;
					color: #2276F5;
					text-align: center;
					margin-top: 15px;
				}

				.xia {
					width: 10vw;
					height: 35vh;
					border: 2px solid #126be750;
					margin-top: 22px;
					padding: 30px;

					.onea {
						font-size: 26px;
						color: #2276F5;
						text-align: center;
						margin-bottom: 1vh;
					}
				}

				.xia:hover {
					background-color: #2276F5;

					.onea {
						color: #fff;
					}
				}

				.two41,
				.two42,
				.two43,
				.two44,
				.two45,
				.two46 {
					margin: 0 18px;
					// flex: 1;
					display: flex;
					flex-direction: column;
					align-items: center;
					.shang{
						flex-direction: column;
						display: flex;
						align-items: center;
					}
				}

				.two41 {
					
					animation: two41 0.5s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0.5;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}

				.two42 {
					
					animation: two41 1s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}

				.two43 {
					animation: two41 1.5s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}

				.two44 {
					animation: two41 2s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}

				.two45 {
					animation: two41 2.5s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}

				.two46 {
					animation: two41 3s;

					@keyframes two41 {
						0% {
							opacity: 0;
						}

						/*初始状态 透明度为0*/
						50% {
							opacity: 0;
						}

						/*过渡状态 透明度为0*/
						100% {
							opacity: 1;
						}

						/*结束状态 透明度为1*/
					}
				}
			}
		}

		.three {
			// position: absolute;
			// background: #0c2f6f;
			// width: 100vw;
			// height: 100vh;
			// background-image: url(../../assets/img/bg_50.webp);
			// background-size: 100% 100%;
			width: 100%;
			height: 100%;
			background: url(../../assets/img/bg_50.webp) 50% bottom / cover;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			

			.three1 {
				font-size: 40px;
				font-weight: 600;
				color: #fff;
				text-align: center;
				// margin-top: 140px;
				animation: three111 2s;
				
				@keyframes three111 {
					0% {
						opacity: 0;
						margin-top: 188px;
					}
				
					100% {
						opacity: 1;
					}
				}
			}

			.three2 {
				font-size: 30px;
				color: #ffffff;
				opacity: 0.5;
				text-align: center;
				margin-top: 10px;
				animation: three2 2s;
				
				@keyframes three2 {
					0% {
						opacity: 0;
						margin-top: 20px;
					}
				
					100% {
						opacity: 1;
					}
				}
				
				// animation: three1 2s;

				// @keyframes three1 {
				// 	0% {
				// 		opacity: 0;
				// 		// margin-top: 3vh;
				// 		// top: 14vh;
				// 		top: 240px;
				// 	}

				// 	100% {
				// 		opacity: 1;
				// 		// margin-top: 1.3vh;
				// 		// top: 12.3vh;
				// 		// top: 140px;
				// 	}
				// }
			}

			.three3 {
				// margin-top: 32.5vh !important;
				// margin-left: 25vw !important;
				animation: three3 2s;
				margin: 0 auto;
				width: 60vw !important;
				position: relative;

				// display: flex;
				// align-items: center;
				// justify-content: center;

				@keyframes three3 {
					0% {
						opacity: 0;
					}

					100% {
						opacity: 1;
					}
				}
			}

			.three4 {
				position: relative;
				// position: absolute;
				font-size: 30px;
				color: #ffffff;
				// top: 33vh;
				// left: 72vw;
				width: 800px;
				// background: indianred;
				img{
					width: 700px;
					margin-top: 50px;
					opacity: .8;
				}

				.three41 {
					// margin-bottom: 0.5vh;
					position: absolute;
					right: -180px;
					top: 0;
				}
				.txt1{
					right: -200px;
					top: 10px;
				}
				.txt2{
					right: -235px;
					top: 60px;
				}
				.txt3{
					right: -205px;
					top: 110px;
				}
				
			}
			
			
			
			.flashIcon {
				position: absolute;
				top: 290px;
				right: 465px;
				z-index: 2;
				height: 10px;
				width: 10px;
				border-radius: 50%;
				-webkit-border-radius: 50%;
				-moz-border-radius: 50%;
				background-color: #F1993A;
				// margin-top: -5px;
			}
			
			.flashIcon:before {
				content: "";
				position: absolute;
				height: 10px;
				width: 10px;
				border-radius: 50%;
				-webkit-border-radius: 50%;
				-moz-border-radius: 50%;
				border: 1px solid #F1993A;
				top: 50%;
				margin-top: -5px;
				left: 50%;
				margin-left: -5px;
				animation-name: blink-a;
				animation-duration: 2s;
				animation-iteration-count: infinite;
				box-sizing: border-box;
			}
			
			.flashIcon:after {
				content: "";
				position: absolute;
				height: 10px;
				width: 10px;
				border-radius: 50%;
				-webkit-border-radius: 50%;
				-moz-border-radius: 50%;
				border: 1px solid #F1993A;
				top: 50%;
				margin-top: -5px;
				left: 50%;
				margin-left: -5px;
				animation-name: blink-b;
				animation-duration: 2s;
				animation-delay: 1s;
				animation-iteration-count: infinite;
				box-sizing: border-box;
			}
			.flashIcon1{
				top: 240px;
				right: 185px;
			}
			.flashIcon1:before {
				animation-duration: 3s;
			}
			.flashIcon1:after{
				animation-duration: 3s;
				animation-delay: 2s;
			}
			.flashIcon2{
				top: 260px;
				right: 265px;
			}
			.flashIcon2:before {
				animation-duration: 3s;
			}
			.flashIcon2:after{
				animation-duration: 3s;
				animation-delay: 2s;
			}
			// --------
			.flashIcon3{
				top: 270px;
				right: 350px;
			}
			.flashIcon3:before {
				animation-duration: 4s;
			}
			.flashIcon3:after{
				animation-duration: 4s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon4{
				top: 320px;
				right: 510px;
			}
			.flashIcon4:before {
				animation-duration: 4s;
			}
			.flashIcon4:after{
				animation-duration: 4s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon5{
				top: 320px;
				right: 220px;
			}
			.flashIcon5:before {
				animation-duration: 2s;
			}
			.flashIcon5:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon6{
				top: 380px;
				right: 210px;
			}
			.flashIcon6:before {
				animation-duration: 4s;
			}
			.flashIcon6:after{
				animation-duration: 4s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon7{
				top: 430px;
				right: 420px;
			}
			.flashIcon7:before {
				animation-duration: 4s;
			}
			.flashIcon7:after{
				animation-duration: 4s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon8{
				top: 350px;
				right: 345px;
			}
			.flashIcon8:before {
				animation-duration: 3s;
			}
			.flashIcon8:after{
				animation-duration: 3s;
				animation-delay: 1s;
			}
			// ---------
			// --------
			.flashIcon9{
				top: 410px;
				right: 305px;
			}
			.flashIcon9:before {
				animation-duration: 3s;
			}
			.flashIcon9:after{
				animation-duration: 3s;
				animation-delay: 1s;
			}
			// ---------
			.flashIcon10{
				top: 520px;
				right: 290px;
			}
			.flashIcon10:before {
				animation-duration: 3s;
			}
			.flashIcon10:after{
				animation-duration: 3s;
				animation-delay: 1s;
			}
			// ---------
			// ---------
			.flashIcon11{
				top: 540px;
				right: 260px;
			}
			.flashIcon11:before {
				animation-duration: 2s;
			}
			.flashIcon11:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			// ---------
			.flashIcon12{
				top: 520px;
				left: 320px;
			}
			.flashIcon12:before {
				animation-duration: 2s;
			}
			.flashIcon12:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			// ---------
			.flashIcon13{
				top: 320px;
				right: 320px;
			}
			.flashIcon13:before {
				animation-duration: 2s;
			}
			.flashIcon13:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			// ---------
			.flashIcon14{
				top: 300px;
				right: 280px;
			}
			.flashIcon14:before {
				animation-duration: 2s;
			}
			.flashIcon14:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			// ---------
			.flashIcon15{
				top: 340px;
				right: 270px;
			}
			.flashIcon15:before {
				animation-duration: 2s;
			}
			.flashIcon15:after{
				animation-duration: 2s;
				animation-delay: 1s;
			}
			// ---------
			@keyframes blink-a {
				0% {
					transform: scale(1, 1);
				}
			
				100% {
					transform: scale(3, 3);
					opacity: 0;
				}
			}
			
			@keyframes blink-b {
				0% {
					transform: scale(1, 1);
				}
			
				100% {
					transform: scale(3, 3);
					opacity: 0;
				}
			}
					
		}

		.four {
			background-image: url("./../../assets/img/bgTwo.png");
		}

		.five {
			position: absolute;
			width: 100vw;
			height: 100vh;
			background: url(../../assets/img/bg_8.webp) 50% bottom / cover;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			.five1 {
				font-size: 40px;
				font-weight: 600;
				color: #ffffff;
				text-align: center;
				
				text-align: center;
				animation: five1 2s;

				@keyframes five1 {
					0% {
						opacity: 0;
						margin-top: 188px;
					}

					100% {
						opacity: 1;
					}
				}
			}

			.five2 {
				font-size: 30px;
				color: #fff;
				margin-top: 10px;
				text-align: center;
				left: 0;
				right: 0;
				text-align: center;
				animation: five2 2s;

				@keyframes five2 {
					0% {
						opacity: 0;
						margin-top: 30px;
					}

					100% {
						opacity: 1;
						// margin-top: 30px;
					}
				}
			}

			.five3 {
				margin-top: 18vh;
				margin-left: 14vw;

				/deep/.carousel-3d-container {
					width: 90vw !important;
					height: 43vh !important;
				}

				/deep/.carousel-3d-slider {
					width: 50vw !important;
					height: 43vh !important;
				}

				/deep/.carousel-3d-slide.left-1 {
					width: 40vw !important;
					height: 30vh !important;
					transform: translateX(-830px) translateZ(-403px) rotateY(348deg) !important;
					margin-top: 18vh !important;
				}

				/deep/.carousel-3d-slide.right-1 {
					width: 40vw !important;
					height: 30vh !important;
					transform: translateX(610px) translateZ(-400px) rotateY(34deg) !important;
					margin-top: 18vh !important;
				}

				/deep/.carousel-3d-slide.current {
					width: 35vw !important;
					height: 60vh !important;
				}
			}

			.honorBox {
				margin: 0 auto;
				width: 1600px;
				margin-top: 60px;

				/deep/.el-carousel__container {
					height: 600px !important;

					img {
						height: 100%;
					}
				}

				/deep/.el-carousel__item h3 {
					color: #475669;
					font-size: 14px;
					opacity: 0.75;
					line-height: 200px;
					margin: 0;
				}

				/deep/.el-carousel__item:nth-child(2n) {
					background-color: #99a9bf;
				}

				/deep/.el-carousel__item:nth-child(2n+1) {
					background-color: #d3dce6;
				}
			}

			.five4 {
				// margin-top: 16vh;
				margin-top: 6vh;
				// margin-left: 5vw;

				.recommendPage {
					position: relative;
					margin: 0 auto;
					// background: azure;
					margin-top: 100px;
					// width: 1340px;
					// width: 100%;
					// height: 456px;
					
					.more {
						position: absolute;
						bottom: -120px;
						left: 50%;
						z-index: 9999999;
						margin-left: -70px;
						// right: 0;
						background: #b46f25;
						width: 120px;
						height: 60px;
						line-height: 60px;
						text-align: center;
						color: #fff;
						cursor: pointer;
						font-size: 20px;
						border-radius: 4px;
					}
				}

				.recommendPage .swiper-container {
					position: relative;
					// width: 100vw;
					// height: 60vh;
				}

				/deep/.swiper-wrapper {
					display: flex !important;
					align-items: center !important;
				}

				.recommendPage .swiper-container .swiper-slide {
					// width: 22%;
					width: 30%;
					// background: red !important;
					display: flex;
					align-items: center;
				}

				/deep/.swiper-slide-active {
					display: flex;
					align-items: center;
					// height: 50vh !important;
					// background: red !important;

				}

				img {
					width: 100%;
					margin: 0 auto;
					// box-shadow: 0px 30px 50px black;
				}
				.moreBox{
					cursor: pointer;
					margin: 0 auto;
					width: 180px;
					height: 50px;
					line-height: 50px;
					margin-top: 40px;
					text-align: center;
					font-size: 18px;
					color: #FFFFFF;
					border: 1px solid #FFFFFF;
					border-radius: 25px;
				}
				.moreBox:hover{
					background: #fff;
					color: #783E00;
				}
			}
		}

		.six {
			// position: absolute;
			width: 100vw;
			height: 100vh;
			background: url(../../assets/img/bg_60.webp) 50% bottom / cover;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			.six1 {
				font-size: 40px;
				font-weight: 600;
				color: #000000;
				text-align: center;
				text-align: center;
				animation: six1 2s;

				@keyframes six1 {
					0% {
						opacity: 0;
						// top: 9.22vh;
						margin-top: 188px;
					}

					100% {
						opacity: 1;
						// top: 7.22vh;
						// margin-top: 80px;
					}
				}
			}

			.six2 {
				font-size: 30px;
				color: #666666;
				margin-top: 10px;
				text-align: center;
				left: 0;
				right: 0;
				// margin-top: 200px;
				text-align: center;
				animation: six2 2s;

				@keyframes six2 {
					0% {
						opacity: 0;
						margin-top: 20px;
					}

					100% {
						opacity: 1;
						// margin-top: .5vh;
					}
				}
			}

			.mateLogo {
				max-width: 1460px;
				display: flex;
				flex-wrap: wrap;
				margin: 0 auto;
				margin-top: 30px;

				.divImg {
					// width: 320px;
					// height: 210px;
					
					// width: 230px;
					// height: 150px;
					
					width: 250px;
					height: 160px;
					margin-left: 21px;
					margin-right: 21px;
					// background: red;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 30px;

					img {
						// width: 320px;
						// width: 230px;
						// height: 150px;
						
						width: 250px;
						height: 160px;
					}
				}

				.divImg:hover {
					box-shadow: 0px 10px 50px rgba(11, 15, 15, .1);

				}

			}



		}

		.seven {
			width: 100vw;
			height: 100vh;
			background: url(../../assets/img/bg_70.webp) 50% bottom / cover;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			.newList{
				margin: 0 auto;
				margin-top: 50px;
				// display: flex;
				// align-items: center;
				width: 1460px;
				// background: indianred;
				.listBox{
					display: flex;
					justify-content: space-between;
					.list{
						cursor: pointer;
						width: 400px;
						height: 503px;
						border: 2px solid #44668F;
						.time{
							margin-left: 56px;
							margin-bottom: 21px;
							margin-top: 20px;
							.span1{
								font-size: 30px;
								color: #FFFFFF;
							}
							.span2{
								margin-left: 14px;
								font-size: 18px;
								color: #899FB9;
							}
						}
						.spanSrc{
							width: 288px;
							height: 172px;
							margin-left: 56px;
							margin-bottom: 28px;
							display: flex;
							align-items: center;
							overflow: hidden;
							.img {
								width: 100% !important;
								margin: 0 auto;
								transition: all 0.6s;
							}
							.img:hover {
								transform: scale(1.4);
							}
						}
						
						.title{
							width: 288px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							font-size: 22px;
							color: #FFFFFF;
							margin-left: 56px;
							margin-right: 56px;
							margin-bottom: 15px;
						}
						.fontTxt{
							height: 50px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;/*截取4行*/
							text-overflow: ellipsis;
							overflow: hidden;
							font-size: 16px;
							color: #8098B4;
							margin-left: 56px;
							margin-right: 56px;
							margin-bottom: 44px;
						}
						.moreList {
							margin-left: 56px;
							width: 130px;
							font-size: 16px;
							color: #fff;
							display: flex;
							align-items: center;
							justify-content: space-between;
							border-bottom: 2px solid #fff;
							padding-bottom: 15px;
							
						
							.triangle {
								width: 0;
								height: 0;
								border-left: 12px solid transparent;
								border-bottom: 12px solid #fff;
								-webkit-transform: rotateZ(-45deg);
								-moz-transform: rotateZ(-45deg);
								-o-transform: rotateZ(-45deg);
								-ms-transform: rotateZ(-45deg);
								transform: rotateZ(-45deg);
							}
						}
						
						
						
					}
					.list:hover{
						background: #fff;
						.time{
							.span1{
								color: #333;
							}
							.span2{
								color: #999;
							}
						}
						.title{
							color: #000;
						}
						.moreList {
							width: 130px;
							color: #2276F5;
							border-bottom: 2px solid #2276F5;
							animation: moreList 1s;
							
							@keyframes moreList {
								0% {
									width: 130px;
								}
							
								100% {
									width: 288px;
								}
							}
						
							.triangle {
								// width: 100%;
								border-bottom: 12px solid #2276F5;
							}
						}
					}
				}
			}
			.moreBox{
				cursor: pointer;
				margin: 0 auto;
				width: 180px;
				height: 50px;
				line-height: 50px;
				margin-top: 40px;
				text-align: center;
				font-size: 18px;
				color: #FFFFFF;
				border: 1px solid #FFFFFF;
				border-radius: 25px;
			}
			.moreBox:hover{
				background: #fff;
				color: #2276F5;
			}
			.seven1 {
				font-size: 40px;
				font-weight: 600;
				color: #ffffff;
				// left: 45vw;
				// top: 148px;
				// position: absolute;
				// z-index: 100;
				// left: 0;
				// right: 0;
				// margin-top: 148px;
				text-align: center;
				animation: seven1 2s;

				@keyframes seven1 {
					0% {
						opacity: 0;
						// top: 9vh;
						margin-top: 188px;
					}

					100% {
						opacity: 1;
						// top: 7.5vh;
						// top: 80px;
					}
				}
			}

			.seven2 {
				font-size: 30px;
				color: #ffffff;
				margin-top: 10px;
				text-align: center;
				animation: seven2 2s;

				@keyframes seven2 {
					0% {
						opacity: 0;
						// top: 14vh;
						margin-top: 30px;
					}

					100% {
						opacity: 1;
						// top: 12.6vh;
						// top: 140px;
					}
				}
			}

			.seven3 {
				// position: absolute;
				// top: 0vh;
				// z-index: -1;

				.seven31 {
					width: 100vw;
					height: 55vh;
				}
			}

			.newsBox {
				width: 1300px;
				margin: 0 auto;
				// margin-top: 600px;
				color: red;
				display: flex;
				justify-content: center;

				.newsDiv {
					display: flex;

					.divList1 {
						// width: 170px;
						margin-top: -180px;

						.divList1Cen {
							margin-bottom: 10px;

							.time {
								font-size: 18px;
								color: #FFFFFF;
							}

							.tit {
								// height: 40px;
								max-width: 180px;
								font-weight: bold;
								font-size: 18px;
								color: #A7CBF4;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
								/*截取4行*/
								text-overflow: ellipsis;
								overflow: hidden;
							}

							.brief {
								height: 50px;
								max-width: 180px;
								font-size: 16px;
								color: #A7CBF4;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								/*截取4行*/
								text-overflow: ellipsis;
								overflow: hidden;
							}
						}

						.wire {
							width: 1px;
							height: 60px;
							border: 1px dashed #FFFFFF;
						}

						.circle {
							margin-left: -6px;
							width: 16px;
							height: 16px;
							background: #FF6969;
							border: 2px solid #FFFFFF;
							box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
							border-radius: 50%;
						}
					}

					.divList2 {
						// width: 170px;
						margin-left: -80px;
						margin-top: -8px;

						.divList1Cen {
							margin-bottom: 10px;

							.time {
								font-size: 18px;
								color: #000;
							}

							.tit {
								max-width: 180px;
								font-weight: bold;
								font-size: 18px;
								color: #666;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
								/*截取4行*/
								text-overflow: ellipsis;
								overflow: hidden;
							}

							.brief {
								height: 50px;
								max-width: 180px;
								font-size: 16px;
								color: #666;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								/*截取4行*/
								text-overflow: ellipsis;
								overflow: hidden;
							}
						}

						.wire {
							width: 1px;
							height: 60px;
							border: 1px dashed #A9B6C4;
						}

						.circle {
							margin-left: -6px;
							width: 16px;
							height: 16px;
							background: #FF6969;
							border: 2px solid #FFFFFF;
							box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
							border-radius: 50%;
						}
					}

					.divList1:hover {}

					.divList1Cen:hover {
						.brief {
							color: red;
						}
					}


				}

				// background: #9ca1dd;
				.newsList {
					display: flex;
					justify-content: center;
					margin-top: -265px;

					.boxDiv {
						margin-left: 50px;
						margin-right: 60px;
						position: relative;
						// width: 170px;

						.newsLocation {
							margin-top: -22px;
							margin-left: 5px;
							height: 260px;
							overflow: hidden;
						}

						.xloc {
							position: absolute;
							top: 10px;
						}

						.data {
							display: flex;
							width: 100px !important;
							font-size: 0.24rem;
							color: #fff;
						}

						.newsCen div:hover {
							color: red;
							font-size: 20px;
						}

						.newsCen div {
							color: #A7CBF4;
							font-size: 0.213333rem;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							/*截取4行*/
							text-overflow: ellipsis;
							overflow: hidden;
							cursor: pointer;
							margin-bottom: 5px;
						}
					}

					.dottedLine {
						width: 0vw;
						height: 18vh;
						border-style: dashed;
						border-color: white;
						border-width: 0.006667rem;
						opacity: 0.5;
					}

					.dotted {
						width: 20px;
						height: 20px;
						border-radius: 50%;
						background: #ff6969;
						// box-shadow: 0 0.026667rem 0.08rem 0 rgb(179 202 245 / 75%);
						border: 2px solid #FFFFFF;
						margin-left: -8px;
					}

					.boxDivs {
						margin-top: 256px;
						// margin-top: -9px;
						margin-left: 50px;
						margin-right: 60px;
						width: 170px;

						.xloc {
							// position: absolute;
							// bottom: 167px;
							// top: 10px;
						}

						.newsLocations {
							// margin-top: -50px;
							margin-left: 5px;
							height: 260px;
							overflow: hidden;
						}

						.data {
							font-size: 0.24rem;
							color: #000;
						}

						.newsCen div:hover {
							color: red;
							font-size: 20px;
						}

						.newsCen div {
							color: #666;
							font-size: 0.213333rem;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							/*截取4行*/
							text-overflow: ellipsis;
							overflow: hidden;
							cursor: pointer;
							margin-bottom: 5px;
						}

						.dottedLine {
							width: 0vw;
							height: 8vh;
							border-style: dashed;
							border-color: #1d1919;
							border-width: 0.006667rem;
							opacity: 0.5;
						}

						.dotted {
							width: 20px;
							height: 20px;
							border-radius: 50%;
							background: #ff6969;
							// box-shadow: 0 0.026667rem 0.08rem 0 rgb(179 202 245 / 75%);
							border: 2px solid #FFFFFF;
							margin-left: -8px;
						}
					}

				}
			}

			//20
			.seven4 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 12vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//28
			.seven5 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 22vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//40
			.seven6 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 32vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//48
			.seven7 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 42vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//60
			.seven8 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 52vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//68
			.seven9 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 62vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//80
			.seven10 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 73vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			//88
			.seven11 {
				width: 1vw;
				height: 1vw;
				position: absolute;
				border-radius: 50%;
				background: #ff6969;
				top: 54vh;
				left: 82vw;
				box-shadow: 0px 2px 6px 0px rgba(179, 202, 245, 0.75);
				border: 2px solid #FFFFFF;
			}

			.seven12 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: white;
				border-width: 0.5px;
				opacity: 0.5;
				left: 12.5vw;
				top: 45vh;
			}

			.seven13 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: rgb(29, 25, 25);
				border-width: 0.5px;
				opacity: 0.5;
				left: 22.4vw;
				top: 57vh;
			}

			.seven14 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: white;
				border-width: 0.5px;
				opacity: 0.5;
				left: 32.5vw;
				top: 45vh;
			}

			.seven15 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: rgb(29, 25, 25);
				border-width: 0.5px;
				opacity: 0.5;
				left: 42.45vw;
				top: 57vh;
			}

			.seven16 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: white;
				border-width: 0.5px;
				opacity: 0.5;
				left: 52.4vw;
				top: 45vh;
			}

			.seven17 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: rgb(29, 25, 25);
				border-width: 0.5px;
				opacity: 0.5;
				left: 62.45vw;
				top: 57vh;
			}

			.seven18 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: white;
				border-width: 0.5px;
				opacity: 0.5;
				left: 73.4vw;
				top: 45vh;
			}

			.seven19 {
				position: absolute;
				width: 0vw;
				height: 8vh;
				border-style: dashed;
				border-color: rgb(29, 25, 25);
				border-width: 0.5px;
				opacity: 0.5;
				left: 82.5vw;
				top: 57vh;
			}

			.seven20 {
				position: absolute;
				color: white;

				.seven201:hover {
					color: red;
					font-size: 20px;
				}

				.seven201 {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					/*截取4行*/
					text-overflow: ellipsis;
					overflow: hidden;
					cursor: pointer;

				}
			}

			.shijian1 {
				height: 9.3vh;
				width: 14vw;
				position: absolute;
				left: 12.4vw;
				top: 35vh;

				.time {
					font-size: 18px;
					color: #fff;
				}

				.seven201 {
					color: #A7CBF4;
					font-size: 16px;
				}
			}

			.shijian2 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 22.4vw;
				top: 66vh;
				color: black;

				.time {
					font-size: 18px;
					color: #000;
				}

				.seven201 {
					color: #666;
					font-size: 16px;
				}
			}

			.shijian3 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 32.4vw;
				top: 35vh;

				.time {
					font-size: 18px;
					color: #fff;
				}

				.seven201 {
					color: #A7CBF4;
					font-size: 16px;
				}
			}

			.shijian4 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 42.4vw;
				top: 66vh;
				color: black;

				.time {
					font-size: 18px;
					color: #000;
				}

				.seven201 {
					color: #666;
					font-size: 16px;
				}
			}

			.shijian5 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 52.3vw;
				top: 35vh;

				.time {
					font-size: 18px;
					color: #fff;
				}

				.seven201 {
					color: #A7CBF4;
					font-size: 16px;
				}
			}

			.shijian6 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 62.4vw;
				top: 66vh;
				color: black;

				.time {
					font-size: 18px;
					color: #000;
				}

				.seven201 {
					color: #666;
					font-size: 16px;
				}
			}

			.shijian7 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 73.3vw;
				top: 35vh;

				.time {
					font-size: 18px;
					color: #fff;
				}

				.seven201 {
					color: #A7CBF4;
					font-size: 16px;
				}
			}

			.shijian8 {
				height: 9.4vh;
				width: 14vw;
				position: absolute;
				left: 82.4vw;
				top: 66vh;
				color: black;

				.time {
					font-size: 18px;
					color: #000;
				}

				.seven201 {
					color: #666;
					font-size: 16px;
				}
			}
		}

		.eight {
			.eight1 {
				font-size: 40px;
				font-weight: 600;
				color: #ffffff;
				left: 43vw;
				// top: 80px;
				top: 148px;
				position: absolute;
				z-index: 100;
				left: 0;
				right: 0;
				text-align: center;
				animation: eight1 2s;

				@keyframes eight1 {
					0% {
						opacity: 0;
						// top: 9vh;
						top: 168px;
					}

					100% {
						opacity: 1;
						// top: 8.5vh;
						// top: 7.5vh;
					}
				}
			}

			.eight2 {
				font-size: 30px;
				font-weight: 300;
				color: #ffffff;
				left: 45vw;
				top: 220px;
				position: absolute;
				z-index: 100;
				left: 0;
				right: 0;
				text-align: center;
				animation: eight2 2s;

				@keyframes eight2 {
					0% {
						opacity: 0;
						// top: 15vh;
						top: 240px;
					}

					100% {
						opacity: 1;
						// top: 12.6vh;
					}
				}
			}

			.eight3 {
				width: 100vw;
				height: 100vh;
				position: absolute;
			}

			.eight4 {
				width: 11vw;
				height: 11vw;
				position: absolute;
				z-index: 1009;
				left: 44.5vw;
				top: 45vh;
				opacity: 1;
			}

			.eight5 {
				// width: 27vw;
				// height: 27vw;
				width: 26vw;
				height: 26vw;
				position: absolute;
				z-index: 1002;
				left: 37vw;
				top: 31vh;
				// animation: jvnenghuan 120s;
				-webkit-animation: jvnenghuan 120s linear infinite;
				-moz-animation: jvnenghuan 1000s linear infinite;
				-o-animation: jvnenghuan 1000s linear infinite;
				animation: jvnenghuan 1000s linear infinite;

				@keyframes jvnenghuan {
					0% {
						// transform: scale(0.6);
						// transform: scale(1);
						transform: rotate(0deg);
					}

					// 1.6% {
					// 	transform: scale(1);
					// }

					// 2% {
					// 	transform: scale(1.3);
					// }

					// 2.5% {
					// 	transform: scale(1);
					// 	transform: rotate(0deg);
					// }

					100% {
						transform: rotate(1000deg);
					}
				}
			}

			.eight6 {
				width: 100vw;
				height: 100vh;
				position: absolute;
				z-index: 1000;
				left: 5vw;
				top: 5vh;
				animation: ruoyinruoxian 8s infinite;

				@keyframes ruoyinruoxian {
					0% {
						opacity: 0;
					}

					50% {
						opacity: 1;
					}

					100% {
						opacity: 0;
					}
				}
			}

			.eight7 {
				width: 100vw;
				height: 100vh;
				position: absolute;
				z-index: 1000;
				left: 0vw;
				top: 0vh;
				animation: ruoyinruoxian1 8s infinite;

				@keyframes ruoyinruoxian1 {
					0% {
						opacity: 1;
					}

					50% {
						opacity: 0;
					}

					100% {
						opacity: 1;
					}
				}
			}

			.eight8 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 34vw;
				top: 26vh;
				animation: fade-in1 2s;

				@keyframes fade-in1 {
					0% {}

					100% {
						width: 100px;
					}
				}
			}

			.eight9 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 28vw;
				top: 40vh;
			}

			.eight10 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 28vw;
				top: 55vh;
			}

			.eight11 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 34vw;
				top: 73vh;
			}

			.eight12 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 70vw;
				top: 26vh;
			}

			.eight13 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 76vw;
				top: 40vh;
			}

			.eight14 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 76vw;
				top: 55vh;
			}

			.eight15 {
				position: absolute;
				width: 10px;
				height: 10px;
				background: white;
				left: 70vw;
				top: 73vh;
			}

			.eight16 {
				position: absolute;
				left: 21.5vw;
				top: 26vh;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;

				img {
					width: 340px;
					margin-left: -10px;
				}
			}

			.eight17 {
				position: absolute;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;
				left: 15.8vw;
				top: 40vh;

				img {
					width: 380px;
					margin-left: -10px;
				}
			}

			.eight18 {
				position: absolute;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;
				left: 15.8vw;
				top: 55vh;

				img {
					width: 380px;
					margin-top: -60px;
					margin-left: -10px;
				}
			}

			.eight19 {
				position: absolute;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;
				left: 21.5vw;
				top: 73vh;

				img {
					width: 340px;
					margin-top: -60px;
					margin-left: -10px;
				}
			}

			.eight20 {
				position: absolute;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;
				left: 72.4vw;
				top: 26vh;

				img {
					width: 340px;
					// margin-top: 10px;
					margin-left: -210px;
				}
			}

			.eight21 {
				position: absolute;
				font-size: 0.266667rem;
				color: #ffffff;
				left: 77.5vw;
				top: 40vh;

				img {
					width: 380px;
					// margin-top: 10px;
					margin-left: -230px;
				}
			}

			.eight22 {
				position: absolute;
				font-size: 20px;
				color: #ffffff;
				left: 74.3vw;
				top: 55vh;

				img {
					width: 380px;
					margin-top: -60px;
					margin-left: -170px;
				}
			}

			.eight23 {
				position: absolute;
				font-size: 20px;
				 
				font-weight: 400;
				color: #ffffff;
				left: 71vw;
				top: 73vh;

				img {
					width: 310px;
					margin-top: -60px;
					margin-left: -160px;
				}
			}

			.eight16,
			.eight17,
			.eight18,
			.eight19,
			.eight20,
			.eight21,
			.eight22,
			.eight23 {
				animation: ff1 3s;

				@keyframes ff1 {
					0% {
						opacity: 0;
					}

					100% {
						opacity: 1;
					}
				}
			}

			.eight24 {
				position: absolute;
				top: 86vh;
				// bottom: 88px;
				left: 50%;
				z-index: 1;
				width: 70%;
				margin-left: -35%;
				// width: 100%;
				// width: 44%;
				// margin-left: 310px;
				// margin-right: 310px;
				// background: red;
				// display: flex;

				.eight24qiantao {
					display: flex;
					justify-content: space-between;

					.eight241 {
						position: relative;
						// margin-left: 5vw;
						// text-align: center;
						width: 195px;
						height: 80px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						.eight2411 {
							position: absolute;
							z-index: -1;
							width: 195px;
							height: 80px;
							// width: 6vw;
							// height: 8vh;
						}

						.eight2414 {
							position: absolute;
							z-index: -1;
							// width: 6vw;
							// height: 8vh;
							display: none;
							width: 195px;
							height: 80px;
						}

						.eight2412 {
							// position: absolute;
							top: 15%;
							// left: 29%;
							// width: 2.3vw;
							// height: 4vh;
							width: 24px;
							height: 24px;
						}

						.eight2413 {
							// position: absolute;
							top: 65%;
							left: 35%;
							// width: 3vw;
							// height: 4vh;
							color: #c2e8ff;
							font-size: 18px;
						}
					}

					.eight241:hover {
						.eight2411 {
							display: none;
						}

						.eight2414 {
							display: block;
						}
					}
				}
			}
		}

		.nine {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			.nine1 {
				font-size: 40px;
				font-weight: 600;
				color: black;
				left: 43vw;
				// top: 7.5vh;
				top: 148px;
				position: absolute;
				z-index: 100;
				left: 0;
				right: 0;
				text-align: center;
				animation: nine1 2s;

				@keyframes nine1 {
					0% {
						opacity: 0;
						// top: 9vh;
						top: 168px;
					}

					100% {
						opacity: 1;
						// top: 80px;
					}
				}
			}

			.nine2 {
				font-size: 30px;
				 
				font-weight: 300;
				color: black;
				// top: 12.6vh;
				top: 220px;
				left: 37vw;
				position: absolute;
				z-index: 100;
				left: 0;
				right: 0;
				text-align: center;
				animation: nine2 2s;

				@keyframes nine2 {
					0% {
						opacity: 0;
						top: 240px;
					}

					100% {
						opacity: 1;
						// top: 140px;
					}
				}
			}

			.nine3 {
				position: absolute;
				width: 35vw;
				height: 34vh;
				top: 45.4vh;
				left: 26.6vw;
				z-index: 100;
			}

			.nine4 {
				position: absolute;
				// width: 372px;
				// height: 368px;
				width: 21vw;
				height: 39vh;
				
				top: 32vh;
				left: 40vw;
			}

			.nine5 {
				position: absolute;
				// width: 575px;
				// height: 304px;
				width: 32vw;
				height: 30vh;
				top: 46.5vh;
				left: 42.9vw;
			}

			.nine6 {
				position: absolute;
				// bottom: 88px;
				top: 88vh;
				/* left: 30vw; */
				display: flex;
				width: 100%;
				justify-content: center;

				.nine61 {
					img {
						width: 200px;
						height: 60px;
					}
				}

				.nine62 {
					padding: 0 60px;
					img {
						width: 200px;
						height: 60px;
					}
				}

				.srcDiv {
					img {
						width: 200px;
						height: 60px;
					}
				}
			}

			.nine7 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 78vh;
				left: 41vw;
			}

			.nine8 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 78.8vh;
				left: 28.6vw;
			}

			.nine9 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 74vh;
				left: 23vw;
			}

			.nine10 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 66vh;
				left: 19vw;
			}

			.nine11 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 56vh;
				left: 22vw;
			}

			.nine12 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 50vh;
				left: 23.4vw;
			}

			.nine13 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 44vh;
				left: 29vw;
			}

			.nine14 {
				position: absolute;
				color: #126ce7;
				font-size: 18px;
				top: 43vh;
				left: 35.4vw;
			}

			.nine15 {
				position: absolute;
				color: #2bd08b;
				font-size: 18px;
				top: 33.8vh;
				left: 68vh;
			}

			.nine16 {
				position: absolute;
				color: #2bd08b;
				font-size: 18px;
				top: 31vh;
				left: 53vw;
			}

			.nine17 {
				position: absolute;
				color: #2bd08b;
				font-size: 18px;
				top: 40.5vh;
				left: 57.5vw;
			}

			.nine18 {
				position: absolute;
				color: #2bd08b;
				font-size: 18px;
				top: 71vh;
				left: 48.1vw;
			}

			.nine19 {
				position: absolute;
				color: #f1993a;
				font-size: 18px;
				top: 45vh;
				left: 59vw;
			}

			.nine20 {
				position: absolute;
				color: #f1993a;
				font-size: 18px;
				top: 51.2vh;
				left: 72vw;
			}

			.nine21 {
				position: absolute;
				color: #f1993a;
				font-size: 18px;
				top: 66vh;
				left: 74.6vw;
			}

			.nine22 {
				position: absolute;
				color: #f1993a;
				font-size: 18px;
				top: 76vh;
				left: 66vw;
			}

			.nine23 {
				position: absolute;
				color: #f1993a;
				font-size: 18px;
				top: 76vh;
				left: 52.8vw;
			}
		}


	}
</style>
